import { render } from "./MenuLinksEditor.vue?vue&type=template&id=4ab1ae06&scoped=true"
import script from "./MenuLinksEditor.vue?vue&type=script&lang=js"
export * from "./MenuLinksEditor.vue?vue&type=script&lang=js"

import "./MenuLinksEditor.vue?vue&type=style&index=0&id=4ab1ae06&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab1ae06"]])

export default __exports__